import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('ui.components.TextField.Controller', {
    required: 'Field is required',
});
